/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\DragGalery\DragGalery.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Friday June 16th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 10th November 2023 08:02:30
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useState, SetStateAction } from "react";
import Box from "Content/DragGalery/Box";
import Styles from "Content/DragGalery/DragGalery.module.css";

type DragGaleryProps = {
    items:{
        id: string;
        Name: string;
        order: number;
        Url?: string;
        toDelete?: boolean;
    }[];
    func: Function;
    onDelete?: Function;
    editable?: boolean;
};

function DragGalery(props: DragGaleryProps) {
    const [dragId, setDragId] = useState();

    const handleDrag = (ev: { currentTarget: { id: SetStateAction<undefined>; }; }) => {
        setDragId(ev.currentTarget.id);
    };

    const handleDrop = (ev: { currentTarget: { id: string; }; }) => {
        const dragBox = props.items.find((box) => box.id === dragId);
        const dropBox = props.items.find((box) => box.id === ev.currentTarget.id);

        const dragBoxOrder = dragBox!.order;
        const dropBoxOrder = dropBox!.order;

        const newBoxState = props.items.map((box) => {
            if (box.id === dragId)
                box.order = dropBoxOrder;

            if (box.id === ev.currentTarget.id)
                box.order = dragBoxOrder;

            return box;
        });

        props.func(newBoxState, dragBox, dropBox);
    };

    const goFirst = (ev: {currentTarget: { id: string; };}) => {
        const boxes = props.items;
        const selectedBox = boxes.find((box) => box.id === ev.currentTarget.id);
        const idxBox = boxes.indexOf(selectedBox!);
        boxes.splice(idxBox, 1);
        boxes.unshift(selectedBox!);

        props.func(boxes.map((val, idx) => {val.order = idx; return val; }), ...boxes);
    };

    return (
        <div className={`${Styles.dragPictureHolder}`}>
            {props.items.sort((a, b) => a.order - b.order)
                .map((box, index) => (
                    <Box
                        editable={props.editable}
                        toDelete={box.toDelete}
                        key={index}
                        index={index}
                        boxNumber={box.id}
                        handleDrag={handleDrag}
                        handleDrop={handleDrop}
                        handleDelete={props.onDelete}
                        PictureURL={box.Url ?? "/public/Default.jpg"}
                        goFirst={goFirst}
                    />
                ))
            }
        </div>
    );
};

export default DragGalery;
